var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',[_c('v-widget',{staticClass:"px-0",attrs:{"title":_vm.titulo,"content-bg":"white"}},[_c('div',{staticClass:"graficaCaptura",attrs:{"slot":"widget-content"},slot:"widget-content"},[_c('p'),_c('br'),_c('e-chart',{attrs:{"path-option":[
          ['dataset.source', _vm.res],
          ['legend.bottom', '0'],
          [
            'color',
            [_vm.color.lightBlue.base, _vm.color.orange.base, _vm.color.grey.base],
          ],
          ['xAxis.show', false],
          ['yAxis.show', false],
          ['series[0].type', 'pie'],
          ['series[0].name', 'captura'],
          ['series[0].avoidLabelOverlap', true],
          ['series[0].radius', ['30%', '50%']],
        ],"height":"430px","width":"100%"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }